/** Default ceiling for auto-sized data-table columns. Manual resizes are never capped. */
export const AUTO_COLUMN_MAX_WIDTH = 400;

/** Clamp an auto-derived column width between the column floor and the auto ceiling. */
export function clampAutoColumnWidth(width: number, minSize: number, maxWidth: number): number {
	return Math.min(maxWidth, Math.max(minSize, width));
}

export interface ResolveColumnWidthInput {
	/** Manual override from `columnSizingState`, or `undefined` when the column is auto-sized. */
	manualWidth: number | undefined;
	/** Best auto width: frozen ?? observed ?? TanStack `getSize()`. */
	autoWidth: number;
	/** Column floor (`columnDef.minSize`). */
	minSize: number;
	/** Auto ceiling. */
	maxWidth: number;
}

/**
 * Resolve a column's render width. Manual overrides keep only the floor and are
 * never capped (the user asked for that width); auto widths get floor + ceiling.
 */
export function resolveColumnWidth({ manualWidth, autoWidth, minSize, maxWidth }: ResolveColumnWidthInput): number {
	if (manualWidth != null) {
		return Math.max(minSize, manualWidth);
	}

	return clampAutoColumnWidth(autoWidth, minSize, maxWidth);
}
